// extracted by mini-css-extract-plugin
export default {"PersistentCartCorrectionBar":"styles_PersistentCartCorrectionBar__vCD5P","ExpandingButton":"styles_ExpandingButton__GKLx3"};